<div class="toasts-area d-flex flex-column justify-content-start align-items-end">

  @for (toast of toasts(); track toast.id) {
    <ngb-toast
      (hidden)="removeToast(toast)"
      [autohide]="true"
      [delay]="toast.delay || 5000"
      [class]="'toast-container type-' + toast.type"
    >
      {{ toast.text }}
    </ngb-toast>
  }

</div>
